import { IOnboardingTarget } from "../GameObjects/IOnboardingTarget";

export class OnboardingStep {
    // Takes a Topic, a Data and a Position, delay, and forceSequence
    public readonly event: string;
    public readonly data: any;
    public readonly target: IOnboardingTarget | undefined;
    public readonly hintDelay: number;
    public readonly isOrdered: boolean;
    public readonly failure: string | undefined;
    public readonly onStart: (() => void) | undefined;
    public readonly onComplete: (() => void) | undefined;
    public skipAndyReaction = false;
    public isComplete: boolean;

    constructor(pEvent: string, pData: any, pTarget: IOnboardingTarget | undefined, pHintDelay: number,
                pIsOrdered: boolean, pFailure?: string, pOnStart?: () => void, pOnComplete?: () => void) {
        this.event = pEvent;
        this.data = pData;
        this.target = pTarget;
        this.hintDelay = pHintDelay;
        this.isOrdered = pIsOrdered;
        this.onStart = pOnStart;
        this.onComplete = pOnComplete;
        this.failure = pFailure;
        this.isComplete = false;
    }
}
